<template>
  <div class="page-train-list">
    <van-tabs class="tabs-view" v-model="active" title-active-color="#FF721B" color="#FF721B" @click="onClickTab"
      swipe-threshold="0">
      <van-tab title="学术活动"></van-tab>
      <van-tab title="进修中心"></van-tab>
    </van-tabs>
    <div v-if="active == 0">
      <form action="/" class="form-flex">
        <van-search v-model="searchValue" right-icon="" placeholder="请输入活动名称" @search="onCourseSearchEnter">
          <template #left-icon>
            <div>
              <van-icon name="search" />
            </div>
          </template>
        </van-search>
        <div class="div-filter" @click="showFilter = !showFilter">
          <img :src="
            require(`@/assets/images/train/icon-filter${curActivity > -1 || curMark > -1 ? '-ing' : ''
              }.png`)
          " class="icon-filter" alt="" />
        </div>
      </form>
      <TrainList ref="trainListComponents" class="train-list-div"></TrainList>
    </div>
    <applicationList ref="application" v-if="active == 1" />
    <div class="filter-fixed" v-show="showFilter">
      <div class="filter-bg" @click="showFilter = false"></div>
      <div class="filter-con">
        <div class="filter-nav">
          <div class="title">活动来源</div>
          <div class="cons">
            <div v-for="(item, index) in activityFrom" :key="index" class="cons-title"
              :class="{ cur: index === curActivity }" @click="handleActivity(index)">
              {{ item.title }}
            </div>
          </div>
        </div>
        <div class="filter-nav mtop">
          <div class="title">医院类型</div>
          <div class="cons">
            <div v-for="(item, index) in hospitalMark" :key="index" class="cons-title" :class="{ cur: index === curMark }" @click="handleMark(index)">
              {{ item.title }}
            </div>
          </div>
        </div>
        <div class="fixed-btn">
          <div class="cancel-btn btn-txt" @click="onRepeat">重 置</div>
          <div class="submit-btn btn-txt" @click="onConfirm">确 认</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TrainList from './components/TrainList.vue'
import { BOOL_SENIOR, BOOL_SENIOR_EMPLOYEE } from '@/utils/configRoles.js'
import applicationList from '@/views/application-study/application-list.vue'
export default {
  name: 'academicActivities',
  components: {
    TrainList,
    applicationList
  },
  data () {
    return {
      active: 0,
      searchValue: '',
      showFilter: false,
      curActivity: -1,
      curMark: -1,
      activityParams: {},
      hospitalParams: {},
      activityFrom: [
        {
          title: '作为参会人参与',
          key: 'studentJoinMark'
        },
        {
          title: '作为主讲人参与',
          key: 'speakerJoinMark'
        }
      ],
      hospitalMark: [
        {
          title: 'DTC医院',
          key: '4'
        },
        {
          title: 'RTC医院',
          key: '1'
        },
        {
          title: '非进修中心',
          key: '023'
        }
      ],
      state: {
        pageNo: 1,
        pageSize: 10,
      },
      searchParams: {},
      pathToFrom: {},
      BOOL_SENIOR,
      BOOL_SENIOR_EMPLOYEE
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.pathToFrom = {
        to,
        from
      }
    })
  },
  mounted () {
    if (BOOL_SENIOR || BOOL_SENIOR_EMPLOYEE) {
      this.activityFrom.push({
        title: '主任医院举办',
        key: 'directorHospitalMark'
      })
    }
    if (window && window.sessionStorage.getItem('trainFilter')) {
      let params = JSON.parse(window.sessionStorage.getItem('trainFilter')).changeNum
      this.curActivity = params.curActivity
      this.curMark = params.curMark
    }
    this.$refs.trainListComponents.handleDefault({})
  },
  methods: {
    onClickTab (e) {
      this.active = e
      if (this.active === 0) {
        this.$nextTick(() => {
          this.searchParams.search = true
          this.$refs.trainListComponents.getDataBaseList(this.searchParams)
        })
        window && window.sessionStorage.removeItem('moduleName')
        window && window.sessionStorage.removeItem('traceTitle')
      } else {
        this.$nextTick(() => {
          this.$refs.application.training = false
        })
        window && window.sessionStorage.setItem('moduleName', '进修中心')
        window && window.sessionStorage.setItem('traceTitle', '进修中心')
      }
    },
    onCourseSearchEnter (e) {
      this.searchParams = {
        title: e
      }
      this.searchParams = Object.assign(this.searchParams, this.hospitalParams, this.activityParams)
      this.$nextTick(() => {
        this.searchParams.search = true
        this.$refs.trainListComponents.getDataBaseList(this.searchParams)
      })
    },
    handleActivity (num) {
      this.curActivity = this.curActivity === num ? -1 : num
      this.searchParams = {
        title: this.searchParams.title,
        hospitalMark: this.searchParams.hospitalMark
      }
      this.activityParams = {
        [this.activityFrom[num].key]: 'Y'
      }
      if (this.curActivity < 0) {
        this.activityParams = {}
      }
    },
    handleMark (num) {
      this.curMark = this.curMark === num ? -1 : num
      this.hospitalParams = {
        hospitalMark: this.hospitalMark[num].key
      }
      if (this.curMark < 0) {
        this.hospitalParams = {}
      }
    },
    onConfirm () {
      this.showFilter = false
      this.searchParams = Object.assign(this.searchParams, this.hospitalParams, this.activityParams)
      this.$nextTick(() => {
        this.searchParams.search = true
        let trainFilter = {
          params: this.searchParams,
          changeNum: {
            curActivity: this.curActivity,
            curMark: this.curMark
          }
        }
        window && window.sessionStorage.setItem('trainFilter', JSON.stringify(trainFilter))
        this.$refs.trainListComponents.getDataBaseList(this.searchParams)
      })
    },
    onRepeat () {
      this.activityParams = {}
      this.hospitalParams = {}
      this.curActivity = -1
      this.curMark = -1
    },
  }
}
</script>

<style lang="less" scoped>
.page-train-list {
  background: #f7f8fa;
  min-height: 100vh;

  .train-list-div {
    padding-top: 100px;
    box-sizing: border-box;
  }

  .filter-fixed {
    position: fixed;
    left: 0;
    width: 100%;
    height: 312px;
    top: 98px;
    background-color: #fff;
    z-index: 99;
    padding: 23px 15px;
    box-sizing: border-box;

    .filter-bg {
      position: absolute;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, .5);
      top: 0;
      left: 0;
      z-index: 98;
    }

    .filter-con {
      position: absolute;
      top: 0;
      left: 0;
      background-color: #fff;
      width: 100%;
      height: 312px;
      background-color: #fff;
      z-index: 99;
      padding: 23px 15px;
      box-sizing: border-box;
    }

    .filter-nav {
      &.mtop {
        margin-top: 18px;
      }

      .title {
        font-size: 16px;
        line-height: 22px;
        color: #333333;
        font-weight: 600;
        position: relative;
        padding-left: 16px;
        margin-bottom: 14px;

        &::before {
          position: absolute;
          width: 4px;
          height: 12px;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          content: '';
          background-color: #EB1700;
          border-radius: 100px;
        }
      }

      .cons {
        display: flex;
        align-content: center;

        .cons-title {
          width: 108px;
          height: 34px;
          line-height: 34px;
          text-align: center;
          margin-right: 12px;
          margin-bottom: 12px;
          background-color: #f6f6f6;
          font-size: 12px;
          color: #333333;

          &.cur {
            background-color: #EB1700;
            color: #fff;
          }
        }
      }
    }

    .fixed-btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 35px;
      box-sizing: border-box;
      position: absolute;
      left: 0;
      width: 100%;
      bottom: 50px;
      z-index: 999;

      .btn-txt {
        width: 144px;
        height: 40px;
        border-radius: 4px;
        line-height: 40px;
        text-align: center;
        font-size: 14px;

        &.cancel-btn {
          border: 1px solid #989898;
          box-sizing: border-box;
        }

        &.submit-btn {
          background-color: #EB1700;
          color: #fff;
        }
      }
    }
  }

  .train-title {
    padding: 20px 0 7px 27px;

    .title-txt {
      line-height: 22px;
      font-size: 16px;
      color: #333333;
      font-weight: 600;
      position: relative;

      &::before {
        position: absolute;
        width: 4px;
        height: 12px;
        background-color: #EB1700;
        border-radius: 4px;
        left: -10px;
        content: '';
        bottom: 4px;
      }
    }
  }

  .form-flex {
    position: fixed;
    top: 42px;
    width: 100%;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;

    .div-filter {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 22px;

      .icon-filter {
        width: 22px;
        height: 22px;
      }
    }
  }

}

/deep/ .van-tabs {
  width: calc(100%);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  border-bottom: 1px solid #f0f1f6;
}

// 搜索框外层整体样式
/deep/ .van-search {
  padding: 14px;
  width: 88vw;
  padding-right: 0;
}

// 搜索框整体样式
/deep/ .van-search__content {
  background: #f5f5f5;
  width: 351px;
  border-radius: 6px;
  padding-left: 0px;
}

// 左侧label样式
/deep/ .van-search__label {
  padding-left: 0px;
  margin-left: 12px;
}

// 左侧图标样式
/deep/ .van-field__left-icon {
  margin-left: 12px;
  margin-right: 6px;
}

// placeholder内文字样式
/deep/ .van-field__control {
  font-weight: 500;
  color: #bbbbbb;
  font-size: 13px;
}

// placeholder内文字样式
/deep/ .van-search__field {
  background-color: transparent !important;
  padding: 5px 10px 5px 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/academicActivities/trainList copy.vue